import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getShopPricingList } from "../api/shopsApi"
import { GetPricingListResultDto, PricingList } from "../models/api/shopApiTypes"
import { Accordion, Card, Col, Container, Form, Row } from "react-bootstrap"
import ShopDetailsImageCarousel from "../components/shop/ShopDetailsImageCarousel"
import Footer from "../components/common/Footer"

export default function PricingListPage() {
  const { shopSlug } = useParams()
  const [data, setData] = useState<GetPricingListResultDto>()
  const [selectedPricingList, setSelectedPricingList] = useState<PricingList>()
  const [selectedCategories, setSelectedCategories] = useState<string[]>([])

  useEffect(() => {
    if (shopSlug !== undefined)
      getShopPricingList(shopSlug)
        .then((result) => {
          setData(result)
          const defaultPricingList =
            result.pricingLists.find((m) => m.isDefault && m.isActive) || result.pricingLists.find((m) => m.isActive)
          setSelectedPricingList(defaultPricingList)
        })
        .catch(() => console.log("Error loading pricing list"))
  }, [shopSlug])

  const togglePricingList = (pricingListName: string) => {
    setSelectedPricingList(data?.pricingLists.find((m) => m.name === pricingListName) || undefined)
    setSelectedCategories([])
  }

  const toggleCategory = (categoryName: string) => {
    setSelectedCategories((prev) =>
      prev.includes(categoryName) ? prev.filter((c) => c !== categoryName) : [...prev, categoryName]
    )
  }

  if (!data || !selectedPricingList) {
    return (
      <Container fluid className="p-4">
        <h4>
          <img
            src={`${process.env.PUBLIC_URL}/img/icons/refresh.svg`}
            alt="Caricamento"
            className="image-loading me-2 mb-1"
          />
          Caricamento&hellip;
        </h4>
      </Container>
    )
  }

  return (
    <>
      <Container fluid className="p-4">
        <div className="shop-title-with-button">
          <h1>{data.name}</h1>
        </div>
        <ShopDetailsImageCarousel img={data.photos} />

        {data.pricingLists.length > 1 ? (
          <Form.Group className="mb-4" controlId="menuSelect">
            <Form.Label>Seleziona listino</Form.Label>
            <Form.Select value={selectedPricingList.name} onChange={(e) => togglePricingList(e.target.value)}>
              {data.pricingLists
                .filter((pl) => pl.isActive)
                .map((menu) => (
                  <option key={menu.name} value={menu.name}>
                    {menu.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
        ) : null}

        {selectedPricingList.categories.length > 1 ? (
          <>
            <Form.Label>Filtra per categoria</Form.Label>
            <div className="mb-4 d-flex flex-wrap gap-2">
              {selectedPricingList.categories.map((category) => (
                <button
                  key={category.name}
                  className={`btn btn-sm ${
                    selectedCategories.includes(category.name) ? "btn-green" : "btn-green-outline"
                  }`}
                  onClick={() => toggleCategory(category.name)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </>
        ) : null}

        <Accordion
          defaultActiveKey={selectedPricingList.categories
            .filter((category) => selectedCategories.length === 0 || selectedCategories.includes(category.name))
            .map((_, index) => String(index))}
          alwaysOpen
        >
          {selectedPricingList.categories
            .filter((category) => selectedCategories.length === 0 || selectedCategories.includes(category.name))
            .map((category, index) => (
              <Accordion.Item eventKey={String(index)} key={category.name}>
                <Accordion.Header>{category.name}</Accordion.Header>
                <Accordion.Body>
                  {category.subCategories.map((subCat) => (
                    <div key={subCat.name} className="mb-4">
                      <h5>{subCat.name}</h5>
                      <Row>
                        {subCat.items.map((item) => (
                          <Col key={item.name} xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Card>
                              {item.imageUrl && <Card.Img variant="top" src={item.imageUrl} alt={item.name} />}
                              <Card.Body>
                                <Card.Title>{item.name}</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">{item.price}</Card.Subtitle>
                                <Card.Text>{item.description}</Card.Text>
                                {item.notes && <small className="text-muted">{item.notes}</small>}
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}
        </Accordion>
      </Container>
      <Footer />
    </>
  )
}
